export const selectFirstMessage = (state) => state.modal.messages[0];
